import i18nInstance from 'i18n/i18nInstance'
import {
  COLLAPSED_PAINTED_DOOR_I18N_NAMESPACE,
  personaFAQ as personaFAQExperiment,
} from '@mc/checkout'
import type { Section } from '@mc/faq'
import { Trans } from '@mc/i18n'
import { getNumberOfInstructors } from '@mc/instructors'
import { categoriesPath } from 'libs/paths'

const t = i18nInstance.getFixedT(null, '@mc/next')

type GetGeneralSectionProps = {
  isEntryPaintedDoorOn?: boolean
  personaFAQ?: boolean
}

export const getGeneralSection: (props: GetGeneralSectionProps) => Section = ({
  isEntryPaintedDoorOn,
  personaFAQ,
}: GetGeneralSectionProps) => ({
  title: t('faq.general.title'),
  questions: [
    {
      title: t('faq.general.question1'),
      uuid: 'faq.general.question1',
      answer: (
        <Trans
          i18nKey='faq.general.answer1'
          values={{ instructors: getNumberOfInstructors() }}
          ns='@mc/next'
        >
          <p className='mc-opacity--hinted' />
          <br />
          <p className='mc-opacity--hinted' />
        </Trans>
      ),
    },
    {
      title: t('faq.general.question2'),
      uuid: 'faq.general.question2',
      answer: (
        <Trans
          i18nKey={
            isEntryPaintedDoorOn
              ? `${COLLAPSED_PAINTED_DOOR_I18N_NAMESPACE}:faq.general.answer2.string`
              : 'faq.general.answer2'
          }
          values={{ instructors: getNumberOfInstructors() }}
          ns='@mc/next'
        >
          <p className='mc-opacity--hinted' />
          <br />
          <p className='mc-opacity--hinted' />
        </Trans>
      ),
    },
    {
      title: t('faq.general.question3'),
      uuid: 'faq.general.question3',
      answer: (
        <Trans i18nKey='faq.general.answer3' ns='@mc/next'>
          <p className='mc-opacity--hinted' />
          <br />
          <span className='mc-opacity--muted mc-text-x-small' />
        </Trans>
      ),
    },
    {
      title: t('faq.general.question4'),
      uuid: 'faq.general.question4',
      answer: (
        <Trans
          i18nKey='faq.general.answer4'
          values={{ instructors: getNumberOfInstructors() }}
          ns='@mc/next'
        >
          <p className='mc-opacity--hinted' />
          <br />
          <p className='mc-opacity--hinted'>
            {/* eslint-disable-next-line jsx-a11y/anchor-has-content */}
            <a href={categoriesPath()} className='mc-text--link' />
          </p>
        </Trans>
      ),
    },
    {
      ...personaFAQExperiment(),
      hide: !personaFAQ,
    },
  ],
})
